// extracted by mini-css-extract-plugin
export default {"ratingOverview":"RatingOverview_ratingOverview__T3VQG","backButton":"RatingOverview_backButton__nzKqo","completedList":"RatingOverview_completedList__fevN4"};